import dayjs from "dayjs"
//导相对时间插件
import relativeTime from 'dayjs/plugin/relativeTime'
import weekYear from 'dayjs/plugin/weekYear'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import isBetween from 'dayjs/plugin/isBetween'
import quarterOfYear from 'dayjs/plugin/quarterOfYear'
//导国际化插件i18n
import 'dayjs/locale/zh-cn'
dayjs.locale('zh-cn')
dayjs.extend(relativeTime)
dayjs.extend(weekYear)
dayjs.extend(weekOfYear)
dayjs.extend(isBetween)
dayjs.extend(quarterOfYear)
export const formatFromNow = (v,emptyText)=>{
  if(!v) return emptyText
  return dayjs(v).fromNow()
}

export const formatDate = (v,format='YYYY-MM-DD',emptyText="")=>{
  if(!v) return emptyText
  return dayjs(v).format(format)
}
export const formatDateTime = (timestamp,format='YYYY-MM-DD HH:mm:ss',emptyText='')=>{
  return formatDate(timestamp,format,emptyText)
}
export const formatWeek = (timestamp)=>{
  if(timestamp==0) return dayjs().week()
  return dayjs(timestamp).week()
}
export const formatFromDay = (v,emptyText)=>{
  if(!v) return emptyText
  const day = dayjs(v)
  if(day.format('YYYYMMDD') == dayjs().format('YYYYMMDD')){
    return day.format('今天 HH:mm')
  }
  if(day.format('YYYYMMDD') == dayjs().add(-1,'day').format('YYYYMMDD')){
    return day.format('昨天 HH:mm')
  }
  return day.format('MM-DD HH:mm')
}

export const formatDay = (timestamp)=>{
  const day = dayjs(timestamp).get('day');
  return day
}

export const formatNumber = (x,decimal)=>{

  var num = parseFloat(x);
	if (isNaN(num)) return

  if(!decimal) return parseFloat(num.toFixed(2))

	return num.toFixed(decimal);
}


export const formatCurrency = (num, sign='', len=2) =>{
  if(!num ) return 0
  // 转换数字
  // 1 标志， 2 整数部分， 3 小数部分
  var intNum = parseInt(num);
  var floatNum = num - intNum;
  // 整数部分每三位添加逗号
  // 转换字符串
  // 每三位插入逗号(转换成数组，通过数组插入)
  var arr = String(intNum).split('');
  // 从最高位开始数，所以从后向前变量
  // 倒数第三个成员前面插入， 不能遍历到第一个位置
  for (var i = arr.length - 3; i > 0; i -= 3) {
      // 在当前位置插入成员
      arr.splice(i, 0, ',')
  }
  // 三个部分拼在一起, 小数不要包含整数部分的0
  floatNum = parseFloat(floatNum.toFixed(len))

  var str = sign + arr.join('')

  if(floatNum != 0 ){
    str += String(floatNum).slice(1)
  }

  return str
}


export const formatFileSize = (fileSize)=>{
  if (fileSize < 1024) {
    return fileSize + 'B';
  } else if (fileSize < (1024*1024)) {
      var temp = fileSize / 1024;
      temp = temp.toFixed(2);
      return temp + 'KB';
  } else if (fileSize < (1024*1024*1024)) {
      var temp = fileSize / (1024*1024);
      temp = temp.toFixed(2);
      return temp + 'MB';
  } else {
      var temp = fileSize / (1024*1024*1024);
      temp = temp.toFixed(2);
      return temp + 'GB';
  }
}
export const formatDayDiff = (timestamp,date,unit='day')=> {
  if(!timestamp || !date) 0
  var curdate = dayjs(date)
  var enddate = dayjs(timestamp)
	if(unit=='day'){
		curdate = dayjs(curdate.format('YYYY-MM-DD'))
		enddate = dayjs(enddate.format('YYYY-MM-DD'))
	}
	return curdate.diff(enddate,unit)
}
export const formatJson = (d)=> {
  return JSON.stringify(d)
}

export const formatDuration = (end,start)=> {
  const date1=dayjs(end)
  const date2=dayjs(start)
  const difference = date1.diff(date2)
  const days = Math.floor(difference/(24*3600*1000));

  const leave1 = difference%(24*3600*1000);
  const hours = Math.floor(leave1/(3600*1000));

  const leave2 = leave1%(3600*1000);
  const minutes = Math.floor(leave2/(60*1000));

  const leave3 = leave2%(60*1000);
  const seconds = Math.floor(leave3/1000);

  return days>0?(days+'天'):''+hours>0?(hours+'小时'):''+minutes>0?(minutes+'分钟'):''+seconds>0?(seconds+'秒'):''
}
